
export class ApiParameterObj {
code: string;
kind: string;
value: Object;
valueOrigin: string;
}

